import React, { FunctionComponent, useState, useEffect } from 'react'; 
import { Row, Col, Card } from 'react-bootstrap';
import { parseToCoin, firstMonthPrice } from '../../services/AmountService';

type ProductResumeProps = {
    title: string,
    priceMonthly: number,
    priceYear: number,
    prorated: boolean,
    annualPayment: boolean
    letMonths: number
}

const ProductResumeCard:FunctionComponent<ProductResumeProps> = (props) => {

  const { title, priceMonthly, priceYear, prorated, annualPayment, letMonths } = props;

  const [ priceProduct, setPriceProduct ] = useState(0);
  const [ proratedPrice, setProratedPrice ] = useState(0);
  const  [onetime, setOnetime] = useState(false);

  useEffect(() => {
    if (priceMonthly==0) {setOnetime(true);setPriceProduct(priceYear)} else {
    const showPrice = annualPayment ? (firstMonthPrice(priceYear) + (priceYear * letMonths)) : priceMonthly;
    setPriceProduct(showPrice)
    if (prorated) {
      const p = annualPayment ? (firstMonthPrice(priceYear) + (priceYear * letMonths)) : firstMonthPrice(priceMonthly);
      setProratedPrice(p);
    }    
  }
  }, [annualPayment])

  return(
    <Card className="product-resume-card mb-3">
      <Card.Body className="p-3">
        <Card.Title>
          <Row>
            <Col md="6"><span className="title-product">{title}</span></Col>
            <Col md="6" className="text-right">
              {onetime ?
              <span><span className="product-price">{parseToCoin(priceProduct)}</span>/one time</span>
              : <span><span className="product-price">{parseToCoin(priceProduct)}</span>{annualPayment ? '/year' : '/month'}</span>
              }
            </Col>
          </Row>
        </Card.Title>
        <div className="border-top my-2"></div>
        {onetime ?
        <Card.Text className="text-right">
          Today's one time payment.
        </Card.Text>
        : <Card.Text className="text-left">
        You'll pay this amount one time plus fees on the first day of the month.
         You'll pay a prorated price of <span className="product-price">{parseToCoin(proratedPrice)}</span > today.
      </Card.Text>
      }
      </Card.Body>
    </Card>
  );
}

export default ProductResumeCard;